export type FrameworkId =
  | 'APEX_VAULT'
  | 'ARCHE_FLOW'
  | 'COMPASS_MERIDIAN'
  | 'HERMES_PRISM'
  | 'LOGOS_NEXUS'
  | 'PRAXIS_MICRO'
  | 'TELOS_FORGE'
  | 'VENTURE_VANTAGE';

export type FrameworkMeta = {
  id: FrameworkId;
  label: string;        // APEX·VAULT™
  domainName: string;   // Capital Allocation — used in classification text
  description: string;  // shown in tooltip
};

export const FRAMEWORKS: FrameworkMeta[] = [
  {
    id: 'APEX_VAULT',
    label: 'APEX·VAULT™',
    domainName: 'Capital Allocation',
    description: 'Governs capital allocation, financial clarity, and investment priority. Applied when decisions carry ROI, cashflow, or GAAP/IFRS implications.',
  },
  {
    id: 'ARCHE_FLOW',
    label: 'ARCHE·FLOW™',
    domainName: 'Organizational Leadership',
    description: 'Governs organisational leadership and process optimisation. Applied when decisions involve authority structure, culture change, or operational bottlenecks.',
  },
  {
    id: 'COMPASS_MERIDIAN',
    label: 'COMPASS·MERIDIAN™',
    domainName: 'Global Strategy',
    description: 'Governs global strategy and macroeconomic intelligence. Applied when decisions involve market entry, geopolitical risk, or cross-border exposure.',
  },
  {
    id: 'HERMES_PRISM',
    label: 'HERMES·PRISM™',
    domainName: 'Marketing & Pricing',
    description: 'Governs marketing management and pricing architecture. Applied when decisions involve demand generation, price elasticity, or go-to-market positioning.',
  },
  {
    id: 'LOGOS_NEXUS',
    label: 'LOGOS·NEXUS™',
    domainName: 'System Dynamics',
    description: 'Governs system dynamics and data-driven decisions. Applied when decisions require feedback loop analysis, predictive analysis, or multi-criteria evaluation.',
  },
  {
    id: 'PRAXIS_MICRO',
    label: 'PRAXIS·MICRO™',
    domainName: 'Applied Economics',
    description: 'Governs applied microeconomics and unit economics. Applied when decisions involve cost structure, market elasticity, or firm-level economic analysis.',
  },
  {
    id: 'TELOS_FORGE',
    label: 'TELOS·FORGE™',
    domainName: 'Operations & Innovation',
    description: 'Governs operations and organisational innovation. Applied when decisions involve execution tracking, scaling readiness, or capability experimentation.',
  },
  {
    id: 'VENTURE_VANTAGE',
    label: 'VENTURE·VANTAGE™',
    domainName: 'Entrepreneurial Strategy',
    description: 'Governs entrepreneurial strategy and competitive intelligence. Applied when decisions involve market opportunities, competitive moat, or venture formation.',
  },
];

export const FRAMEWORK_BY_ID = Object.fromEntries(
  FRAMEWORKS.map((f) => [f.id, f])
) as Record<FrameworkId, FrameworkMeta>;

export type ConfidenceLevel = 'High' | 'Moderate' | 'Low';

export function confidenceLevel(score: number): ConfidenceLevel {
  if (score >= 0.75) return 'High';
  if (score >= 0.50) return 'Moderate';
  return 'Low';
}
